import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "addSwiper",
  data: function data() {
    return {
      form: {
        id: "",
        language: "",
        img: "",
        url: "",
        sort: "" // status: 1,

      },
      dialogShow: false,
      fileList: [],
      rules: {
        sort: [{
          required: true,
          message: "请输入排序",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = {
                    id: data.id,
                    language: data.language,
                    img: data.img,
                    url: data.url,
                    sort: data.sort
                  };
                  _this.fileList = [data.img];
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      this.fileList = e;
      this.form.img = e[0] && e[0].response ? e[0].response.data : '';
    },
    urlChange: function urlChange(e) {},
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        language: "",
        sort: "",
        img: "",
        url: ""
      };
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'bannerUpdate' : 'bannnerAdd';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};